const RENGIAMAS = "801"
const PRIIMTAS = "802"
const ATMESTAS = "803" 
const LAUKIA_APMOKEJIMO = "804"
const ATMESTINAS = "805"
const LAUKIA_PATVIRTINIMO = "806"
const APMOKETAS = "807"
const IVYKDYTAS = "808"
const LAUKIA_PASIRASYMO = "809"
const ATSAUKTAS = "810"
const ATSISAKYTA_PASIRASYTI = "811"
const ATMESTAS_AUTO = "812" 
const ATSTOVU_TIKRINIMAS = "813" 
const ATSTOVAI_PATVIRTINTI = "814" 
const ATSTOVAI_NETINKAMI = "815"

export default {
    RENGIAMAS: RENGIAMAS,
    PRIIMTAS: PRIIMTAS,
    ATMESTAS: ATMESTAS, 
    LAUKIA_APMOKEJIMO: LAUKIA_APMOKEJIMO,
    ATMESTINAS: ATMESTINAS,
    LAUKIA_PATVIRTINIMO: LAUKIA_PATVIRTINIMO,
    APMOKETAS: APMOKETAS,
    IVYKDYTAS: IVYKDYTAS,
    LAUKIA_PASIRASYMO: LAUKIA_PASIRASYMO,
    ATSAUKTAS: ATSAUKTAS,
    ATSISAKYTA_PASIRASYTI: ATSISAKYTA_PASIRASYTI,
    ATMESTAS_AUTO: ATMESTAS_AUTO,
    ATSTOVU_TIKRINIMAS: ATSTOVU_TIKRINIMAS,
    ATSTOVAI_PATVIRTINTI: ATSTOVAI_PATVIRTINTI,
    ATSTOVAI_NETINKAMI: ATSTOVAI_NETINKAMI
}